import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { Table, Layout, Modal, Button, Popover } from 'antd'
import { app, config } from "../app"
import Head from "../components/Head"
import api from "../api"
import utils from "../utils"
import NewsDetail from "../components/NewsDetail"
import '../css/rescue.css'

const { Header, Content } = Layout

class NewsList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: 1,
            total: 0,
            dataList: [],
            detail_visible: false,
            detail_data: {}
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.handleData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据源
     */
    handleData = async (page) => {
        await this.setData({ page, dataList: [], data_loading: true })
        let { flag, data, msg, total } = await app.post(api.NewsLists, {
            page,
            type: '1'
        })
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                data_loading: false,
                dataList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 打开详情
     */
    handleOpenDetail = async (id) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        let state = { detail_loading: false }
        let { flag, data, msg } = await app.post(api.NewNewsDetails, {
            id,
            request: 'news',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            data.id = id
            state.detail_data = data
            console.log(data)
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    /**
     * 关闭详情
     */
    handleCancelDetail = () => {
        this.setData({ detail_visible: false })
    }

    render () {
        const { loading, dataList, page, total, detail_visible, detail_data, detail_loading, data_loading } = this.state,
            columns = [
                {
                    title: '封面图片',
                    dataIndex: 'news_img',
                    key: 'news_img',
                    width: '15%',
                    render: (img) => {
                        if (img) {
                            let src = config.imgUrl + img
                            return (
                                <a href={src} target='_blank'>
                                    <div className="news-img">
                                        <img src={src} alt=""/>
                                    </div>
                                </a>
                            )
                        } else {
                            return '已清除'
                        }
                    }
                },
                {
                    title: '标题',
                    dataIndex: 'news_title',
                    key: 'news_title',
                    width: '20%',
                    render: (title) => (
                        <span title={title}
                              style={{ wordBreak: 'break-all' }}>{title.length > 20 ? title.substr(0, 20) + '...' : title}</span>)
                },
                {
                    title: '级别',
                    dataIndex: 'object_type',
                    key: 'object_type',
                    width: '10%',
                    render (type) {
                        switch (type) {
                            case '1':
                                return (<span>全国</span>)
                            case '2':
                                return (<span>省级</span>)
                            case '3':
                                return (<span>队伍</span>)
                            default:
                                return ''
                        }
                    }
                },
                {
                    title: '发布对象',
                    dataIndex: 'object',
                    key: 'object',
                    width: '15%',
                },
                {
                    title: '发布时间',
                    dataIndex: 'release_time',
                    key: 'release_time',
                    width: '15%',
                },
                {
                    title: '浏览量',
                    dataIndex: 'hits',
                    key: 'hits',
                    width: '10%',
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '15%',
                    render: (id) => {
                        return (
                            <span>
                                <Button size="small" type="primary" style={{ marginRight: '1rem' }}
                                        onClick={() => this.handleOpenDetail(id)}>详情</Button>
                                <Popover placement="left"
                                         content={<QRCode value={config.shareDoman + id}/>}
                                         title="手机扫码分享" overlayStyle={{ textAlign: 'center' }}>
                                    <Button size="small" type="primary">分享</Button>
                                </Popover>
                            </span>

                        )
                    }
                },
            ]
        return (
            <Layout className="rescue-list">
                <Header style={{ height: 'auto', padding: 0 }}>
                    <Head background="#3F89C1" height={104} history={this.props.history}/>
                </Header>
                <Content className="rl_content">
                    <Table className="table"
                           locale={app.tbLocale(data_loading)}
                           columns={columns}
                           dataSource={dataList}
                           loading={data_loading}
                           scroll={{ y: 'calc(100% - 63px)' }}
                           title={() => <div className="table_title">新闻列表</div>}
                           pagination={{
                               current: page,
                               total,
                               pageSize: 20,
                               showTotal: (total) => `总数: ${total}`,
                               onChange: this.handleData
                           }}/>
                </Content>
                <Modal
                    visible={detail_visible}
                    footer={null}
                    title="新闻详情"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh' }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={this.handleCancelDetail}
                    zIndex={1010}
                    className="news-detail-modal-class"
                >
                    <NewsDetail data={detail_data} loading={detail_loading}/>
                </Modal>
            </Layout>
        )
    }
}

export default NewsList



// WEBPACK FOOTER //
// ./src/routes/NewsList.jsx